import React from 'react';
import DatePicker from 'react-datepicker';
import { de } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './ActivitiesTable.css';

// Languages array from LanguagePopUp
const languagesData = ["Deutsch", "English", "Français", "Italiano", "Español", "Polski", "Português", "Nederlands", "Русский", "Українська", "Türkçe", "العربية", "עברית", "日本語", "中文", "한국어", "Baskisch", "Belarussisch", "Bengali", "Bosnisch", "Bulgarisch", "Dänisch", "Estnisch", "Finnisch", "Galicisch", "Georgisch", "Griechisch", "Haitianisch", "Hawaiisch", "Hebräisch", "Hindi", "Hmong", "Igbo", "Indonesisch", "Irisch", "Isländisch", "Javanisch", "Kannada", "Katalanisch", "Khmer", "Kinyarwanda", "Kirgisisch", "Koreanisch", "Korsisch", "Kroatisch", "Kurdisch", "Laotisch", "Lateinisch", "Lettisch", "Litauisch", "Luxemburgisch", "Malagasy", "Malayalam", "Malaysisch", "Maltesisch", "Maori", "Marathi", "Mazedonisch", "Mongolisch", "Nepali", "Norwegisch", "Paschtu", "Persisch", "Punjabi", "Rumänisch", "Samoanisch", "Schottisch", "Schwedisch", "Serbisch", "Sesotho", "Shona", "Sindhi", "Singhalesisch", "Slowakisch", "Slowenisch", "Somali", "Suaheli", "Sundanesisch", "Tadschikisch", "Tamil", "Telugu", "Thailändisch", "Tschechisch", "Türkmenisch", "Ungarisch", "Urdu", "Usbekisch", "Vietnamesisch", "Walisisch", "Xhosa", "Yoruba", "Zulu"];

// Einsatzart options
const einsatzartData = ["Aktenanlage", "Anhörung", "Vor-Ort-Übersetzung (schriftlich)"];

const ActivitiesTable = ({ activities, onActivityChange, onActivityDateChange }) => {
    const formatTime = (date) => {
        if (!date) return '';
        return date.toLocaleTimeString('de-DE', { 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: false 
        });
    };

    return (
        <div className="activities-table-container">
            <div className="activities-table-header">
                <div className="activities-table-icon"></div>
                <h3>Aktivitäten</h3>
            </div>
            <table className="activities-table">
                <thead>
                    <tr>
                        <th>Planzeit</th>
                        <th>Istzeit</th>
                        <th>Einsatzart</th>
                        <th>Sprache/Dialekt</th>
                    </tr>
                </thead>
                <tbody>
                    {activities.map((activity, index) => (
                        <tr key={index}>
                            <td className="time-column">
                                <div className="time-display">
                                    {formatTime(activity.planzeitStart)} - {formatTime(activity.planzeitEnd)}
                                </div>
                                <div className="time-pickers">
                                    <DatePicker
                                        selected={activity.planzeitStart}
                                        onChange={(date) => onActivityDateChange(date, index, 'planzeitStart')}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        dateFormat="HH:mm"
                                        className="time-picker-start"
                                        locale={de}
                                    />
                                    <DatePicker
                                        selected={activity.planzeitEnd}
                                        onChange={(date) => onActivityDateChange(date, index, 'planzeitEnd')}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        dateFormat="HH:mm"
                                        className="time-picker-end"
                                        locale={de}
                                    />
                                </div>
                            </td>
                            <td className="time-column">
                                <div className="time-display">
                                    {formatTime(activity.istzeitStart)} - {formatTime(activity.istzeitEnd)}
                                </div>
                                <div className="time-pickers">
                                    <DatePicker
                                        selected={activity.istzeitStart}
                                        onChange={(date) => onActivityDateChange(date, index, 'istzeitStart')}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        dateFormat="HH:mm"
                                        className="time-picker-start"
                                        locale={de}
                                    />
                                    <DatePicker
                                        selected={activity.istzeitEnd}
                                        onChange={(date) => onActivityDateChange(date, index, 'istzeitEnd')}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        dateFormat="HH:mm"
                                        className="time-picker-end"
                                        locale={de}
                                    />
                                </div>
                            </td>
                            <td>
                                <select 
                                    name="einsatzart" 
                                    value={activity.einsatzart} 
                                    onChange={(e) => onActivityChange(e, index)} 
                                    className="einsatzart-select" 
                                >
                                    <option value="">-- Einsatzart wählen --</option>
                                    {einsatzartData.map((einsatzart, einsatzIndex) => (
                                        <option key={einsatzIndex} value={einsatzart}>
                                            {einsatzart}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <select 
                                    name="sprache" 
                                    value={activity.sprache} 
                                    onChange={(e) => onActivityChange(e, index)} 
                                    className="language-select" 
                                >
                                    <option value="">-- Sprache wählen --</option>
                                    {languagesData.map((language, langIndex) => (
                                        <option key={langIndex} value={language}>
                                            {language}
                                        </option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ActivitiesTable; 
